export enum TaskTrackerItemState {
    Undef = 0,
    NotActive = 1,
    InProgress = 2,
    Done = 3,
    Removed = 4
}
